import React, { RefObject } from "react";
import { Appointment, Calendar } from "../../../@types/appointments";
import { map } from "lodash";
import classNames from "classnames";
import moment from "moment";
import AppointmentItem from "components/appointments/appointmentsList/AppointmentItem";
import MobileAppointmentItem from "components/appointments/appointmentsList/mobile/MobileAppointmentItem";

type CalendarDayArgs = {
  appointments: Appointment[];
  day: string;
  calendars?: Calendar[];
  todayRef: RefObject<HTMLDivElement>;
};

export default function CalendarDay({
  appointments,
  day,
  calendars,
  todayRef,
}: CalendarDayArgs) {
  const today = moment();
  const date = moment(day);

  const ItemComponent = window.isApp ? MobileAppointmentItem : AppointmentItem;

  return (
    <div
      className={classNames("cal-day grid grid-cols-[1fr] p-1.5", {
        "md:grid-cols-[100px,1fr] gap-2 md:p-2 border-t border-box-border-color -mt-px":
          !window.isApp,
        "past-month past-day": today.isAfter(date, "month"),
        "past-day": today.isAfter(date, "day"),
        "today bg-primary/10 border-primary/50 border-x rounded border-y -mx-px -mb-0.5":
          today.isSame(date, "day") && !window.isApp,
        "today bg-primary/10 first:pt-5 last:mb-5":
          today.isSame(date, "day") && window.isApp,
        future: today.isBefore(date),
        "px-0 pt-5 first:pt-0 last:pb-5": window.isApp,
      })}
    >
      <div
        className={classNames("date", {
          "font-medium mb-2 px-5 text-lg": window.isApp,
        })}
      >
        {date.format(I18n.t("js.plugins.Locale.Formats.day_in_month"))}
      </div>
      <div
        className={classNames("", {
          "flex flex-col gap-2 divide-y divide-neutral/25": window.isApp,
        })}
      >
        {map(appointments, (appointment) => {
          return (
            <ItemComponent
              key={appointment.id}
              appointment={appointment}
              date={date}
              calendars={calendars}
              todayRef={todayRef}
            />
          );
        })}
      </div>
    </div>
  );
}
